<section class="Upload">
	<!-- Take or Select photos -->
	<section class="Upload__images">
		<!-- Input to select photos -->
		<input
			multiple
			#selectPhotoInput
			class="Upload__hidden"
			type="file"
			accept="image/*;capture=camera"
			(change)="onHandleFile($event)"
		/>
		<!-- Input to take photos -->
		<input
			multiple
			#takePhotoInput
			class="Upload__hidden"
			type="file"
			accept="image/*;capture=environment"
			(change)="onHandleFile($event)"
		/>
	</section>

	<!-- File Preview -->
	<section class="Preview" [class.Margin-bottom--s]="filesPreview().length">
		<section *ngFor="let filePreview of filesPreview()" class="Preview__item">
			<img [src]="filePreview.preview" [alt]="filePreview.file.name" />
			<section class="s">
				<p>{{ filePreview.file.name }}</p>
			</section>
		</section>
	</section>

	<!-- Actions -->
	<section class="Upload__actions">
		<app-button color="green" [outline]="true" [isFull]="true" (clicked)="onSelectPhoto()">
			subir foto
		</app-button>
		<app-button color="green" [isFull]="true" (clicked)="onTakePhoto()"> tomar foto </app-button>
	</section>
</section>

